module.exports = "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHZpZXdCb3g9IjAgMCAxMDI0IDEwMjQiIHZlcnNpb249IjEuMSI+PHBhdGggZD0iTTU4MC4yIDE4NS42YTE2IDE2IDAgMCAwLTQuMiAxMC44VjM1Mkg5NmEzMiAzMiAwIDAgMC0zMiAzMnYyNTZhMzIgMzIgMCAwIDAgMzIgMzJoNDgwdjE1NS42YTE2IDE2IDAgMCAwIDI2LjggMTEuOGwzNDQuMy0zMTUuNmExNiAxNiAwIDAgMCAxLTIyLjZsLTEtMS0zNDQuMy0zMTUuNmExNiAxNiAwIDAgMC0yMi42IDF6IiBmaWxsPSIjMCIgcC1pZD0iMzI0OSI+PC9wYXRoPjwvc3ZnPg=="


//////////////////
// WEBPACK FOOTER
// ./src/assets/icons/svg/Arrow-right-filled.svg
// module id = aUqI
// module chunks = 75